import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import DisiApi from "datas/disi/DisiApi";
import PartnerDepositUseCase from "domains/interactor/main/disi/PartnerDeposit";
import ConstantsResult from "domains/entity/main/ConstantResult";

type iState = {
    data: ConstantsResult;
    loading: boolean;
    error: any
}

const initialState: iState = {
    data: [],
    loading: false,
    error: ""
}

export const partnerDepositGetStatusAction = createAsyncThunk('partner-deposit-get-status', async (_, { rejectWithValue }) => {
    try {
        const useCase = new PartnerDepositUseCase(new DisiApi())
        return await useCase.getPartnerStatus()
    } catch (error) {
        const { response = null } = error
        if (!response) {
            throw error
        }
        return rejectWithValue(response.data)
    }
})

const partnerDepositStatusSlice = createSlice({
    name: "partner-deposit-status-slice",
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(partnerDepositGetStatusAction.pending, state => {
            state.loading = true;
            state.error = ""
        })
        builder.addCase(partnerDepositGetStatusAction.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload
            state.error = ""
        })
        builder.addCase(partnerDepositGetStatusAction.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        })
    }
})

const partnerDepositStatusReducer = partnerDepositStatusSlice.reducer

export default partnerDepositStatusReducer